import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExplainerSectionWrapper = ({
  id,
  children,
  maxInlineSize = '1200px'
}) => {
  return /*#__PURE__*/_jsx(CardWrapper, {
    borderRadius: "400",
    id: id,
    overflow: "hidden",
    marginBlockEnd: "0",
    maxInlineSize: maxInlineSize,
    margin: "auto",
    children: /*#__PURE__*/_jsx(CardSection, {
      margin: "0",
      padding: "0",
      children: children
    })
  });
};